import axios from '@/axios'
import API from '@/API'

const PREFIX = 'icon'

export default {
  datatable(params) {
    return axios.get(`${API.endpoint}/${PREFIX}/datatable`, {
      params: params
    })
  },
  detail(id) {
    return axios.get(`${API.endpoint}/${PREFIX}/detail/${id}`)
  },
  store(data) {
    return axios.post(`${API.endpoint}/${PREFIX}/add`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',        
      }
    })
  },
  update(id, data) {
    return axios.post(`${API.endpoint}/${PREFIX}/update/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',        
      }
    })
  },
  delete(id) {
    return axios.post(`${API.endpoint}/${PREFIX}/delete/${id}`)
  }
}